import ENDPOINTS from "../ApiManager/HabitacionEndPoints";
import environment from "../environments/environment";

const BASE_URL = environment.api_url;

class HabitacionService {
	
	static getHabitaciones = (establecimientoId) => {
		const url = BASE_URL + ENDPOINTS.GET_HABITACIONES()+establecimientoId;
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	

	static getHabitacionesByParams = (establecimientoId, activo, estado, edificio, planta,terminada, combinarCamas, usuario, asignadas, noAsignadas) => {
		const url = BASE_URL + ENDPOINTS.GET_HABITACIONES_BY_PARAMS(establecimientoId,activo,estado, edificio, planta, usuario, asignadas, noAsignadas, terminada, combinarCamas);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	
	static getHabitacionesAsignables = (establecimientoId,estado, edificio, planta, usuario) => {
		const url = BASE_URL + ENDPOINTS.GET_HABITACIONES_ASIGNABLES(establecimientoId,estado, edificio, planta, usuario);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	
	static getEstadosHabitacion = () => {
		const url = BASE_URL + ENDPOINTS.GET_ESTADOS_HABITACION();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	}
	
	static crearHabitacion = (habitacion) => {
		const url = BASE_URL + ENDPOINTS.POST_HABITACION();

		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				establecimiento: habitacion.establecimiento,
				edificio: habitacion.edificio,
				planta: habitacion.planta,
				numero: habitacion.numero,
				activo: habitacion.activo,
				estadoHabitacion: habitacion.estadoHabitacion
			})
		});
	};
	
	static actualizarHabitacion = (habitacion) => {
		const url = BASE_URL + ENDPOINTS.ACTUALIZAR_HABITACION(habitacion.id);

		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				establecimiento: habitacion.establecimiento,
				edificio: habitacion.edificio,
				planta: habitacion.planta,
				numero: habitacion.numero,
				activo: habitacion.activo,
				estadoHabitacion: habitacion.estadoHabitacion,
				combinarCamas: habitacion.combinarCamas
			})
		});
	};
	
	static desactivarHabitacion = (habitacionId) => {
		const url = BASE_URL + ENDPOINTS.DELETE_HABITACION() + habitacionId;

		return fetch(url, {
			method: 'DELETE',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};
	
	static cargarFicheroHabitaciones = (establecimientoId, fichero, borrar) => {
		const url = BASE_URL + ENDPOINTS.CARGAR_FICHERO_HABITACIONES(establecimientoId, borrar);

		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				nombre: fichero.nombre,
				contenido: fichero.contenido
			})
		});
	};
	
	static marcarNoTerminada = (habitacionId) => {
		const url = BASE_URL + ENDPOINTS.MARCAR_NO_TERMINADA(habitacionId) ;

		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};
	
	static validaHabitacion = (habitacionId, usuario) => {
		const url = BASE_URL + ENDPOINTS.VALIDAR_HABITACION(habitacionId, usuario) ;

		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};
	
}

export default HabitacionService;
